<template>
  <sub-page title="培训补贴办理">
    <div class="subsidy-page">
      <div class="page-title">请选择补贴类型</div>

      <div class="type-list">
        <div :class="['type-card', { active: selected === 'cert' }]" @click="selectType('cert')">
          <div class="type-icon orange">
            <svg viewBox="0 0 24 24" class="icon"><rect x="4" y="4" width="16" height="16" rx="2" fill="none" stroke="#ff976a" stroke-width="2"/><path d="M8 12 L11 15 L16 9" fill="none" stroke="#ff976a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div class="type-text">获证补贴申请</div>
          <div class="type-desc">取得职业资格证书后申领</div>
        </div>
        <div :class="['type-card', { active: selected === 'train' }]" @click="selectType('train')">
          <div class="type-icon green">
            <svg viewBox="0 0 24 24" class="icon"><rect x="4" y="4" width="16" height="16" rx="2" fill="none" stroke="#07c160" stroke-width="2"/><path d="M12 8 L12 16 M8 12 L16 12" fill="none" stroke="#07c160" stroke-width="2" stroke-linecap="round"/></svg>
          </div>
          <div class="type-text">培训补贴申请</div>
          <div class="type-desc">完成培训并考核合格后申领</div>
        </div>
      </div>

      <!-- 获证补贴表单 -->
      <template v-if="selected === 'cert'">
        <div class="form-title">获证补贴申请信息</div>
        <div class="form-body">
          <div class="form-item">
            <span class="form-label required">证书名称</span>
            <input v-model="certForm.certName" class="form-input" placeholder="如：半导体芯片制造工（四级）" />
          </div>
          <div class="form-item">
            <span class="form-label required">证书编号</span>
            <input v-model="certForm.certNo" class="form-input" placeholder="请输入证书编号" />
          </div>
          <div class="form-item">
            <span class="form-label required">发证日期</span>
            <input v-model="certForm.issueDate" class="form-input" placeholder="如：2026-08-20" />
          </div>
          <div class="form-item">
            <span class="form-label required">发证机关</span>
            <input v-model="certForm.issuer" class="form-input" placeholder="请输入发证机关" />
          </div>
          <div class="form-item">
            <span class="form-label required">补贴金额</span>
            <span class="form-value">1500 元</span>
          </div>
        </div>
      </template>

      <!-- 培训补贴表单 -->
      <template v-if="selected === 'train'">
        <div class="form-title">培训补贴申请信息</div>
        <div class="form-body">
          <div class="form-item">
            <span class="form-label required">班期名称</span>
            <input v-model="trainForm.className" class="form-input" placeholder="如：2021012081" />
          </div>
          <div class="form-item">
            <span class="form-label required">培训机构</span>
            <input v-model="trainForm.org" class="form-input" placeholder="请输入培训机构名称" />
          </div>
          <div class="form-item">
            <span class="form-label required">培训工种</span>
            <input v-model="trainForm.job" class="form-input" placeholder="请输入培训工种" />
          </div>
          <div class="form-item">
            <span class="form-label required">考核结果</span>
            <span class="form-value">合格</span>
          </div>
          <div class="form-item">
            <span class="form-label required">结束时间</span>
            <input v-model="trainForm.endDate" class="form-input" placeholder="如：2026-08-30" />
          </div>
          <div class="form-item">
            <span class="form-label required">补贴金额</span>
            <span class="form-value">800 元</span>
          </div>
        </div>
      </template>

      <div class="tips-section">
        <div class="tips-title">温馨提示</div>
        <div class="tips-item">1. 请确保您的个人信息准确无误，以免影响补贴发放。</div>
        <div class="tips-item">2. 补贴将发放至本人社会保障卡金融账户，请确认已激活金融功能。</div>
        <div class="tips-item">3. 同一职业（工种）同一等级只能享受一次获证补贴；如有疑问请拨打 12333。</div>
      </div>

      <div class="footer-btns">
        <button class="upload-btn" :disabled="!selected" @click="uploadMaterial">上传材料</button>
        <button class="submit-btn" :disabled="submitted || !selected" @click="handleSubmit">{{ submitted ? '已提交' : '提交' }}</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'TrainingSubsidy',
  components: { SubPage },
  data() {
    return {
      selected: '',
      submitted: false,
      certForm: { certName: '', certNo: '', issueDate: '', issuer: '' },
      trainForm: { className: '', org: '', job: '', endDate: '' }
    }
  },
  methods: {
    selectType(type) {
      if (this.submitted) return
      this.selected = type
    },
    uploadMaterial() {
      if (!this.selected) {
        this.$alert('请先选择补贴类型')
        return
      }
      this.$alert(this.selected === 'cert'
        ? '请上传职业资格证书、身份证等材料（演示环境）'
        : '请上传培训合格证明、培训发票等材料（演示环境）')
    },
    handleSubmit() {
      if (!this.selected) {
        this.$alert('请先选择补贴类型')
        return
      }
      if (this.selected === 'cert') {
        const f = this.certForm
        const checks = [
          [!f.certName, '请输入证书名称'],
          [!f.certNo, '请输入证书编号'],
          [!f.issueDate, '请输入发证日期'],
          [!f.issuer, '请输入发证机关']
        ]
        for (const [cond, msg] of checks) {
          if (cond) { this.$alert(msg); return }
        }
        if (!/^\d{4}-\d{2}-\d{2}$/.test(f.issueDate)) {
          this.$alert('发证日期格式应为 YYYY-MM-DD')
          return
        }
        this.$alert('获证补贴申请已提交，补贴金额 1500 元，审核通过后将发放至您的社会保障卡金融账户')
      } else {
        const f = this.trainForm
        const checks = [
          [!f.className, '请输入班期名称'],
          [!f.org, '请输入培训机构'],
          [!f.job, '请输入培训工种'],
          [!f.endDate, '请输入培训结束时间']
        ]
        for (const [cond, msg] of checks) {
          if (cond) { this.$alert(msg); return }
        }
        if (!/^\d{4}-\d{2}-\d{2}$/.test(f.endDate)) {
          this.$alert('结束时间格式应为 YYYY-MM-DD')
          return
        }
        this.$alert('培训补贴申请已提交，补贴金额 800 元，审核通过后将发放至您的社会保障卡金融账户')
      }
      this.submitted = true
    }
  }
}
</script>

<style scoped>
.subsidy-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.page-title {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  text-align: center;
  padding: calc(40 * var(--w)) 0 calc(32 * var(--w));
}
.type-list {
  display: flex;
  justify-content: space-around;
  padding: 0 calc(32 * var(--w));
  gap: calc(24 * var(--w));
}
.type-card {
  flex: 1;
  background: #fff;
  border: 2px solid transparent;
  border-radius: calc(12 * var(--w));
  padding: calc(32 * var(--w)) calc(24 * var(--w));
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(12 * var(--w));
  cursor: pointer;
}
.type-card.active {
  border-color: #2E8CF6;
  background: #F2F8FF;
}
.type-icon {
  width: calc(80 * var(--w));
  height: calc(80 * var(--w));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.type-icon.orange {
  background: #fff5e8;
}
.type-icon.green {
  background: #e8f8f0;
}
.icon {
  width: calc(44 * var(--w));
  height: calc(44 * var(--w));
}
.type-text {
  font-size: calc(30 * var(--w));
  color: #323233;
  font-weight: 500;
}
.type-desc {
  font-size: calc(22 * var(--w));
  color: #969799;
  text-align: center;
  line-height: 1.4;
}
.form-title {
  font-size: calc(30 * var(--w));
  font-weight: bold;
  color: #323233;
  padding: calc(32 * var(--w)) calc(32 * var(--w)) calc(16 * var(--w));
}
.form-body {
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  min-height: calc(100 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(20 * var(--w));
}
.form-item:last-child {
  border-bottom: none;
}
.form-label {
  font-size: calc(28 * var(--w));
  color: #323233;
  width: calc(190 * var(--w));
  flex-shrink: 0;
}
.form-label.required::before {
  content: '*';
  color: #f00;
  margin-right: calc(4 * var(--w));
}
.form-value {
  flex: 1;
  font-size: calc(28 * var(--w));
  color: #D88230;
  font-weight: bold;
}
.form-input {
  flex: 1;
  height: calc(100 * var(--w));
  border: none;
  outline: none;
  font-size: calc(28 * var(--w));
  color: #323233;
  background: transparent;
}
.form-input::placeholder {
  color: #c8c9cc;
}
.tips-section {
  margin-top: calc(32 * var(--w));
  padding: 0 calc(32 * var(--w));
}
.tips-title {
  font-size: calc(30 * var(--w));
  color: #ee0a24;
  font-weight: bold;
  margin-bottom: calc(16 * var(--w));
}
.tips-item {
  font-size: calc(26 * var(--w));
  color: #646566;
  line-height: 1.8;
}
.footer-btns {
  display: flex;
  gap: calc(24 * var(--w));
  padding: calc(40 * var(--w)) calc(32 * var(--w));
}
.upload-btn,
.submit-btn {
  flex: 1;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
.upload-btn {
  background: #fff;
  color: #2E8CF6;
  border: 1px solid #2E8CF6;
}
button:disabled {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/TrainingSubsidy.vue